define('global/Extensions',[
    'jquery',
    './Logger'
], function($, Logger) {
    'use strict';


    function getAttributeValue(customFields, key) {
        if (!customFields || customFields[key] === null || customFields[key] === undefined ||
            ($.isArray(customFields[key]) && customFields[key].length === 0)) {
            return null;
        }
        
        return $.isArray(customFields[key])
            ? customFields[key][0].value
            : customFields[key];
    }

    function b64DecodeUnicode(str) {
        return decodeURIComponent(Array.prototype.map.call(atob(str), function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    function downloadFile(file, filename) {
        var uncoded = b64DecodeUnicode(file);
        var blob = new Blob([uncoded], { type: 'text/plain' });

        if (navigator.msSaveOrOpenBlob) {
            // Works for Internet Explorer and Microsoft Edge
            navigator.msSaveOrOpenBlob(blob, filename);
        } else {

            var a = document.createElement('a');
            a.download = filename;
            a.href = window.URL.createObjectURL(blob);
            a.textContent = 'Download ready';

            a.draggable = true;
            a.classList.add('dragout');

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        }
    }

    // source: http://stackoverflow.com/questions/24080018/download-file-from-an-asp-net-web-api-method-using-angularjs
    function saveFile(data, filename) {
        var contentType = 'application/octet-stream';
        var success = false;
        var blob, url;

        try {
            // Try using msSaveBlob if supported
            blob = new Blob([data], { type: contentType });
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                // Try using other saveBlob implementations, if available
                var saveBlob = navigator.webkitSaveBlob ||
                    navigator.mozSaveBlob ||
                    navigator.saveBlob;
                if (saveBlob === undefined) {
                    throw 'Not supported';
                }
                saveBlob(blob, filename);
            }
            success = true;
        } catch (ex) {
            Logger.debug('saveBlob method failed with the following exception:');
            Logger.debug(ex);
        }

        if (!success) {
            // Get the blob url creator
            var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
            if (urlCreator) {
                // Try to use a download link
                var link = document.createElement('a');
                if ('download' in link) {
                    // Try to simulate a click
                    try {
                        // Prepare a blob URL
                        blob = new Blob([data], { type: contentType });
                        url = urlCreator.createObjectURL(blob);
                        link.setAttribute('href', url);

                        // Set the download attribute (Supported in Chrome 14+ / Firefox 20+)
                        link.setAttribute('download', filename);

                        // Simulate clicking the download link
                        var event = document.createEvent('MouseEvents');
                        event
                            .initMouseEvent('click', true, true,
                                window, 1, 0, 0,
                                0, 0, false, false, false,
                                false, 0, null);
                        link.dispatchEvent(event);
                        success = true;

                    } catch (e) {
                        Logger
                            .debug('Download link method with simulated click failed with the following exception:');
                        Logger.debug(e);
                    }
                }

                if (!success) {
                    // Fallback to window.location method
                    try {
                        // Prepare a blob URL
                        // Use application/octet-stream when using window.location to force download
                        blob = new Blob([data], { type: contentType });
                        url = urlCreator.createObjectURL(blob);
                        window.location = url;
                        success = true;
                    } catch (exc) {
                        Logger
                            .debug('Download link method with window.location failed with the following exception:');
                        Logger.debug(exc);
                    }
                }

            }
        }

        if (!success) {
            // Fallback to window.open method
            Logger
                .debug('No methods worked for saving the arraybuffer, using last resort window.open');
            window.open(endpoint, '_blank', '');
        }
    }

    function hasCustomFields(obj) {
        return obj !== undefined &&
            obj !== null &&
            obj.customFields !== undefined &&
            obj.customFields !== null;
    }
    

    var Extensions = {
        getAttributeValue: getAttributeValue,
        downloadFile: downloadFile,
        saveFile: saveFile,
        hasCustomFields: hasCustomFields
    }

    Logger.debug('Extensions.js Loaded:', Extensions);

    return Extensions;


});
